import Tweeter from "../Images/Projects/TweeterImg.png";
import TF1 from "../Images/Projects/TradefinderImg.jpeg";
import Resin from "../Images/Projects/ResinImg.png";
import Scheduler from "../Images/Projects/SchedulerImg.png";
import GS from "../Images/Projects/GameSetaImg.png";

// Hero banner flip images — stack logos in src/Images/Stacks/
import reactLogo from "../Images/Stacks/react.svg";
import vueLogo from "../Images/Stacks/vue.svg";
import nuxtLogo from "../Images/Stacks/nuxt.svg";
import javascriptLogo from "../Images/Stacks/javascript.svg";
import storybookLogo from "../Images/Stacks/storybook.svg";
import nodejsLogo from "../Images/Stacks/nodejs.svg";
import expressLogo from "../Images/Stacks/express.svg";
import railsLogo from "../Images/Stacks/rails.svg";
import postgresqlLogo from "../Images/Stacks/postgresql.svg";
import mysqlLogo from "../Images/Stacks/mysql.svg";
import mongodbLogo from "../Images/Stacks/mongodb.svg";
import githubLogo from "../Images/Stacks/github.svg";
import jestLogo from "../Images/Stacks/jest.svg";
import cypressLogo from "../Images/Stacks/cypress.svg";

/** Images shown in the hero banner — edit this list or add files to Images/Stacks/ */
export const HERO_BANNER_IMAGES = [
  reactLogo,
  vueLogo,
  nuxtLogo,
  javascriptLogo,
  nodejsLogo,
  expressLogo,
  railsLogo,
  postgresqlLogo,
  mysqlLogo,
  mongodbLogo,
  githubLogo,
  jestLogo,
  cypressLogo,
  storybookLogo,
];

export { HERO_BANNER_IMAGES as HONEYCOMB_IMAGES };

export const ABOUT_HIGHLIGHTS = [
  { label: "Focus", value: "Website development" },
  { label: "Strength", value: "Detail & Thoroughness" },
  { label: "Current Stacks", value: "Rails, Vue & Nuxt" },
  { label: "Based in", value: "Southern Ontario area" },
];

export const HOW_I_WORK = [
  {
    title: "Polish the details",
    description:
      "When I'm building a site, I care about the finish - spacing, broken states, and small UI issues that are easy to miss. I'd rather catch them before release than after.",
    accent: "magenta",
  },
  {
    title: "Cover every path",
    description:
      "On tickets, I walk through different inputs, flows, and edge cases - not just the happy path - so the fix holds up when it's actually in use.",
    accent: "coral",
  },
  {
    title: "Learn by doing",
    description:
      "I pick things up fastest when I'm hands-on in the code - building, breaking, and fixing. That's usually when something really clicks for me.",
    accent: "blue",
  },
];

export const ABOUT_PARAGRAPHS = [
  "I came into web development through a career change.",
  "I trained at Lighthouse Labs, where I picked up JavaScript, React, Ruby, and what it takes to ship under a deadline.",
  "These days my work spans both sides - Ruby on Rails on the backend and Nuxt/Vue on the frontend. I care about UI quality, test beyond the happy path before closing a ticket, and learn best by getting hands-on with the work.",
  "This site is a snapshot of what I do - the stacks I work with, projects I've built, and the kind of developer I am.",
];

export const EXPERIENCE_INTRO =
  "Bootcamp training, volunteer projects, and professional roles. Professional details here are kept general — shareable builds are in the Work section.";

export const EXPERIENCE = [
  {
    id: "professional-present",
    period: "2021-Present",
    role: "Lead Developer",
    org: "Professional role",
    summary:
      "Leading a small team across Rails and Nuxt/Vue, from backend APIs and database work through to frontend delivery. Work has touched captive portal builds, ongoing CMS and API development, and external vendor integrations.",
    accent: "purple",
  },
  {
    id: "professional-2020",
    period: "2020-2021",
    role: "Full-stack Developer",
    org: "Professional role",
    summary:
      "Worked on a staff rotation scheduling platform with React and Java — backend services, APIs, and frontend features. Also built an internal email tool in React, backed by a Google Doc of templates. Starting at the department level, users narrow down layer by layer until they reach the email template they need.",
    accent: "magenta",
  },
  {
    id: "gameseta",
    period: "2020",
    role: "Platform Developer",
    org: "GameSeta (volunteer)",
    summary:
      "Built a platform for high school esports teams to track performance against competing schools. Chose MongoDB to learn a new stack while delivering a real product for a startup.",
    accent: "blue",
  },
  {
    id: "lighthouse",
    period: "2020",
    role: "Web Development Bootcamp",
    org: "Lighthouse Labs",
    summary:
      "Intensive full-stack program covering JavaScript, React, Ruby on Rails, PostgreSQL, and modern tooling. Completed solo and team projects under tight deadlines.",
    accent: "coral",
  },
];

export const SKILL_GROUPS = [
  {
    title: "Frontend",
    skills: ["Nuxt", "Vue", "React", "JavaScript", "HTML & CSS", "Storybook", "Responsive UI"],
  },
  {
    title: "Backend",
    skills: ["Ruby on Rails", "Java", "Node.js", "Express", "PostgreSQL", "MySQL", "MongoDB"],
  },
  {
    title: "Tools & practices",
    skills: ["Git", "Jest", "Cypress", "REST APIs", "Code review", "Debugging"],
  },
];

export const PROJECTS = [
  {
    id: "portfolio",
    title: "This portfolio",
    stack: ["React", "CSS"],
    image: null,
    featured: true,
    description:
      "Personal site rebuilt with a refreshed layout, scroll-aware navigation, and a custom animated hero.",
    links: [],
    accent: "magenta",
  },
  {
    id: "gameseta",
    title: "GameSeta",
    stack: ["Express", "React", "MongoDB"],
    image: GS,
    description:
      "Esports performance platform for high school teams. Built as a volunteer project with MongoDB for flexible team and game data.",
    links: [
      {
        label: "Dribbble",
        href: "https://dribbble.com/shots/14694768-Gaming-Performance-Monitoring",
        type: "dribbble",
      },
    ],
    accent: "purple",
  },
  {
    id: "tradefinder",
    title: "Tradefinder",
    stack: ["PostgreSQL", "React", "Ruby on Rails"],
    image: TF1,
    description:
      "Final bootcamp team app for finding and reviewing local tradespeople. Integrated Mailgun and Twilio for contact and live chat.",
    links: [
      {
        label: "GitHub",
        href: "https://github.com/J-sabharwal/Tradefinders",
        type: "github",
      },
    ],
    accent: "blue",
  },
  {
    id: "scheduler",
    title: "Scheduler",
    stack: ["React", "Storybook", "Cypress", "Jest"],
    image: Scheduler,
    description:
      "Interview scheduling SPA with component-driven development in Storybook and test coverage via Jest and Cypress.",
    links: [
      {
        label: "GitHub",
        href: "https://github.com/J-sabharwal/scheduler",
        type: "github",
      },
    ],
    accent: "coral",
  },
  {
    id: "resin",
    title: "ResIn",
    stack: ["jQuery", "PostgreSQL", "Express"],
    image: Resin,
    description:
      "Collaborative resource hub for students — save, categorize, and review learning materials in one place.",
    links: [
      {
        label: "GitHub",
        href: "https://github.com/J-sabharwal/ResIn",
        type: "github",
      },
    ],
    accent: "purple",
  },
  {
    id: "tweeter",
    title: "Tweeter",
    stack: ["jQuery", "AJAX", "Express"],
    image: Tweeter,
    description:
      "Early Twitter clone focused on jQuery and AJAX — posting tweets and getting comfortable with async patterns.",
    links: [
      {
        label: "GitHub",
        href: "https://github.com/J-sabharwal/tweeter",
        type: "github",
      },
    ],
    accent: "magenta",
  },
];

export const SOCIAL_LINKS = [
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/in/j-sabharwal",
    type: "linkedin",
  },
  {
    label: "GitHub",
    href: "https://github.com/J-sabharwal",
    type: "github",
  },
  {
    label: "Dribbble",
    href: "https://dribbble.com/Sabharwal",
    type: "dribbble",
  },
];
